(function () {
'use strict';
document.documentElement.classList.add('jw-js');
var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var smallScreen = window.matchMedia('(max-width: 767px)').matches ||
(window.matchMedia('(pointer: coarse)').matches && window.innerWidth < 1024);
var throttleLoops = smallScreen;
var hero = document.querySelector('[data-jw-hero]');
var sticky = document.querySelector('[data-jw-sticky]');
if (hero && sticky && 'IntersectionObserver' in window) {
var io = new IntersectionObserver(function (entries) {
entries.forEach(function (e) {
sticky.classList.toggle('jw-show', !e.isIntersecting);
});
}, { threshold: 0.08 });
io.observe(hero);
} else if (sticky) {
sticky.classList.add('jw-show');
}
var revealEls = document.querySelectorAll('.jw-reveal');
document.querySelectorAll('[data-jw-reveal-group]').forEach(function (group) {
var kids = group.querySelectorAll('.jw-reveal');
kids.forEach(function (kid, idx) {
kid.style.setProperty('--jw-d', Math.min(idx * 0.06, 0.5).toFixed(2) + 's');
});
});
if (reduceMotion || !('IntersectionObserver' in window)) {
revealEls.forEach(function (el) { el.classList.add('jw-in'); });
} else {
var revealIO = new IntersectionObserver(function (entries) {
entries.forEach(function (e) {
if (e.isIntersecting) {
e.target.classList.add('jw-in');
revealIO.unobserve(e.target);
}
});
}, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
revealEls.forEach(function (el) { revealIO.observe(el); });
}
var ambientSections = document.querySelectorAll('.jw-ambient');
if (ambientSections.length && !reduceMotion && 'IntersectionObserver' in window) {
var ambientIO = new IntersectionObserver(function (entries) {
entries.forEach(function (e) {
e.target.classList.toggle('jw-ambient-on', e.isIntersecting);
});
}, { rootMargin: '120px 0px' });
ambientSections.forEach(function (sec) { ambientIO.observe(sec); });
}
var introLayer = document.querySelector('[data-jw-intro]');
if (introLayer) {
if (reduceMotion) {
introLayer.remove();
} else {
var introDone = false;
var introCleanup = function () {
if (introDone) return;
introDone = true;
introLayer.remove();
};
introLayer.addEventListener('animationend', function (e) {
if (e.animationName === 'jw-intro-a' || e.animationName === 'jw-intro-b') {
window.setTimeout(introCleanup, 120);
}
});
window.setTimeout(function () {
introLayer.classList.add('jw-intro-go');
window.setTimeout(introCleanup, 3450);
}, 250);
}
}
if (reduceMotion) return;
var watchVideo = document.querySelector('[data-jw-watch-video]');
if (watchVideo && watchVideo.getAttribute('data-src') && 'IntersectionObserver' in window) {
var watchLoaded = false;
new IntersectionObserver(function (entries) {
entries.forEach(function (e) {
if (e.isIntersecting) {
if (!watchLoaded) {
watchLoaded = true;
watchVideo.src = watchVideo.getAttribute('data-src');
watchVideo.load();
}
var wp = watchVideo.play();
if (wp && wp.catch) wp.catch(function () {  });
} else if (watchLoaded) {
watchVideo.pause();
}
});
}, { rootMargin: '240px 0px', threshold: 0.1 }).observe(watchVideo);
}
var stage = document.querySelector('[data-jw-stage]');
var stageCard = document.querySelector('[data-jw-stage-card]');
var cardSpin = document.querySelector('[data-jw-card-spin]');
if (stage && stageCard && cardSpin) {
var finePointer = window.matchMedia('(pointer: fine)').matches;
var tiltTX = 0, tiltTY = 0, tiltX = 0, tiltY = 0;
var parTX = 0, parTY = 0, parX = 0, parY = 0;
var dragRX = 0, dragRXCur = 0;
var rotY = 0, spinVel = 0;
var rotAnim = null;
var hovering = false, dragging = false, stageLive = false;
var lastX = 0, lastY = 0, downT = 0, moved = 0;
function easeInOut(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
function nearestFace(v) { return Math.round(v / 180) * 180; }
function nearestTurn(v) { return Math.round(v / 360) * 360; }
function animateRot(to, dur) {
rotAnim = { from: rotY, to: to, start: performance.now(), dur: dur };
spinVel = 0;
}
function flipCard() {
if (dragging || rotAnim) return;
var half = Math.round(rotY / 180);
var showingBack = ((half % 2) + 2) % 2 === 1;
var target = showingBack ? nearestTurn(rotY) : nearestTurn(rotY) + 180;
animateRot(target, 650);
}
stage.addEventListener('pointermove', function (e) {
if (dragging) {
var dx = e.clientX - lastX, dy = e.clientY - lastY;
lastX = e.clientX; lastY = e.clientY;
moved += Math.abs(dx) + Math.abs(dy);
rotY += dx * 0.45;
spinVel = spinVel * 0.65 + dx * 0.45 * 0.35;
dragRX = Math.max(-20, Math.min(20, dragRX - dy * 0.22));
rotAnim = null;
} else if (finePointer && e.pointerType === 'mouse') {
var r = stage.getBoundingClientRect();
var nx = ((e.clientX - r.left) / r.width - 0.5) * 2;
var ny = ((e.clientY - r.top) / r.height - 0.5) * 2;
tiltTY = Math.max(-14, Math.min(14, nx * 14));
tiltTX = Math.max(-14, Math.min(14, -ny * 14));
parTX = nx * 10; parTY = ny * 8;
}
});
stage.addEventListener('pointerenter', function () { hovering = true; });
stage.addEventListener('pointerleave', function () {
hovering = false;
if (!dragging) { tiltTX = 0; tiltTY = 0; parTX = 0; parTY = 0; }
});
stage.addEventListener('pointerdown', function (e) {
dragging = true; moved = 0;
lastX = e.clientX; lastY = e.clientY;
downT = performance.now();
rotAnim = null; spinVel = 0;
stage.classList.add('jw-dragging');
if (stage.setPointerCapture) {
try { stage.setPointerCapture(e.pointerId); } catch (err) {  }
}
});
function endDrag() {
if (!dragging) return;
dragging = false;
stage.classList.remove('jw-dragging');
if (moved < 6 && performance.now() - downT < 350) {
flipCard();
spinVel = 0;
}
}
stage.addEventListener('pointerup', endDrag);
stage.addEventListener('pointercancel', endDrag);
var resetBtn = document.querySelector('[data-jw-stage-reset]');
var spinBtn = document.querySelector('[data-jw-stage-spin]');
var flipBtn = document.querySelector('[data-jw-stage-flip]');
if (resetBtn) resetBtn.addEventListener('click', function () {
tiltTX = 0; tiltTY = 0; parTX = 0; parTY = 0; dragRX = 0;
animateRot(nearestTurn(rotY), 900);
});
if (spinBtn) spinBtn.addEventListener('click', function () {
animateRot(nearestFace(rotY) + 360, 1400);
});
if (flipBtn) flipBtn.addEventListener('click', flipCard);
var stageVisible = true, stageRAF = 0, stageTick = 0, lastNow = 0;
function stageFrame(now) {
stageRAF = requestAnimationFrame(stageFrame);
if (throttleLoops && (stageTick++ % 2)) return;
var dt = lastNow ? Math.min(50, now - lastNow) : 16;
lastNow = now;
var t = now / 1000;
if (rotAnim) {
var ap = (now - rotAnim.start) / rotAnim.dur;
if (ap >= 1) { rotY = rotAnim.to; rotAnim = null; }
else rotY = rotAnim.from + (rotAnim.to - rotAnim.from) * easeInOut(ap);
} else if (!dragging && spinVel !== 0) {
rotY += spinVel * (dt / 16.7);
spinVel *= Math.pow(0.94, dt / 16.7);
if (Math.abs(spinVel) <= 0.35) animateRot(nearestFace(rotY), 1200);
}
if (!dragging) dragRX += (0 - dragRX) * 0.06;
tiltX += (tiltTX - tiltX) * 0.1;
tiltY += (tiltTY - tiltY) * 0.1;
parX += (parTX - parX) * 0.1;
parY += (parTY - parY) * 0.1;
dragRXCur += (dragRX - dragRXCur) * 0.12;
var bob = Math.sin(t * 1.6) * 6;
var sway = Math.sin(t * 0.9) * 2;
stageCard.style.transform =
'translate3d(' + parX.toFixed(1) + 'px,' + (parY + bob).toFixed(1) + 'px,0)' +
' rotateX(' + (tiltX + dragRXCur).toFixed(2) + 'deg)' +
' rotateY(' + tiltY.toFixed(2) + 'deg)' +
' rotateZ(' + sway.toFixed(2) + 'deg)';
cardSpin.style.transform = 'rotateY(' + rotY.toFixed(2) + 'deg)';
var live = hovering || dragging || !!rotAnim || Math.abs(spinVel) > 0.5;
if (live !== stageLive) {
stageLive = live;
stage.classList.toggle('jw-stage-live', live);
}
}
function stagePlay() {
if (!stageRAF && stageVisible && !document.hidden) {
lastNow = 0;
stageRAF = requestAnimationFrame(stageFrame);
}
}
function stagePause() {
if (stageRAF) { cancelAnimationFrame(stageRAF); stageRAF = 0; lastNow = 0; }
}
if ('IntersectionObserver' in window && hero) {
new IntersectionObserver(function (entries) {
entries.forEach(function (e) {
stageVisible = e.isIntersecting;
if (stageVisible) stagePlay(); else stagePause();
});
}, { threshold: 0.05 }).observe(hero);
}
document.addEventListener('visibilitychange', function () {
if (document.hidden) stagePause(); else stagePlay();
});
stagePlay();
}
var flyer = document.querySelector('[data-jw-flyer]');
var flipBlock = document.querySelector('[data-jw-flip]');
var orderSec = document.getElementById('order');
var footer = document.querySelector('.jw-footer');
if (!flyer || !hero) return;
var cur = { x: 0, y: 0, r: 0, s: 1, o: 0 };
var flipStart = -1, flipArmed = true;
function docTop(el) {
var y = 0;
while (el) { y += el.offsetTop || 0; el = el.offsetParent; }
return y;
}
function lerpKey(keys, p) {
if (p <= keys[0][0]) return keys[0][1];
for (var i = 1; i < keys.length; i++) {
if (p <= keys[i][0]) {
var p0 = keys[i - 1][0], p1 = keys[i][0];
var v0 = keys[i - 1][1], v1 = keys[i][1];
return v0 + (v1 - v0) * ((p - p0) / (p1 - p0));
}
}
return keys[keys.length - 1][1];
}
var pathX = [[0, 0.05], [0.18, 0.60], [0.38, 0.10], [0.58, 0.64], [0.78, 0.14], [1, 0.66]];
var pathY = [[0, 0.16], [0.25, 0.34], [0.5, 0.20], [0.75, 0.36], [1, 0.13]];
var flyTick = 0;
function frame(now) {
requestAnimationFrame(frame);
if (throttleLoops && (flyTick++ % 2)) return;
var vw = window.innerWidth, vh = window.innerHeight;
var sy = window.scrollY || window.pageYOffset;
var start = docTop(hero) + hero.offsetHeight - vh * 0.55;
var end = orderSec ? docTop(orderSec) - vh * 0.45 : start + 1;
var p = (sy - start) / Math.max(1, end - start);
p = Math.max(0, Math.min(1, p));
var tx = lerpKey(pathX, p) * vw;
var ty = lerpKey(pathY, p) * vh + Math.sin(now * 0.0022 + p * 14) * 7;
var ts = 1;
var to = p <= 0.01 ? 0 : 1;
var landed = false;
if (orderSec) {
var orc = orderSec.getBoundingClientRect();
if (orc.top < vh * 0.55 && orc.bottom > vh * 0.3) {
landed = true;
tx = vw * 0.68; ty = vh * 0.12; ts = 0.88;
}
}
if (footer && footer.getBoundingClientRect().top < vh * 0.75) to = 0;
var flipExtra = 0;
if (flipBlock) {
var fr = flipBlock.getBoundingClientRect();
var centreDist = Math.abs((fr.top + fr.height / 2) - vh * 0.5);
if (flipArmed && centreDist < vh * 0.16) {
flipStart = now; flipArmed = false;
}
if (fr.bottom < 0 || fr.top > vh) flipArmed = true;
}
if (flipStart > 0) {
var ft = (now - flipStart) / 950;
if (ft >= 1) {
flipStart = -1;
cur.r -= 360;
} else {
var fe = 1 - Math.pow(1 - ft, 3);
flipExtra = 360 * fe;
}
}
var bank = landed ? 0 : Math.max(-20, Math.min(20, (tx - cur.x) * 0.10));
cur.x += (tx - cur.x) * 0.055;
cur.y += (ty - cur.y) * 0.055;
cur.s += (ts - cur.s) * 0.06;
cur.o += (to - cur.o) * 0.12;
cur.r += ((bank + flipExtra) - cur.r) * (flipStart > 0 ? 0.35 : 0.08);
flyer.style.opacity = cur.o.toFixed(3);
flyer.style.transform =
'translate3d(' + cur.x.toFixed(1) + 'px,' + cur.y.toFixed(1) + 'px,0)' +
' rotate(' + cur.r.toFixed(1) + 'deg) scale(' + cur.s.toFixed(3) + ')';
}
requestAnimationFrame(frame);
})();